<template>
  <div id="insec-real" style=" overflow: hidden">
    <div class="insecReal-data">
      <div class="insecReal-data-head">
        <div class="insecReal-head-left">
          <div class="insecReal-left-title">
            <div class="insecReal-left-title-container">杀虫灯实时数据</div>
          </div>
          <div class="insecReal-left-state">
            <div class="insecReal-left-state-container">设备状态：{{insecDeviceSate}}</div>
          </div>
        </div>
        <div class="insecReal-head-right">
          <div class="insecReal-head-right-container">
            设备名
            <el-select @change="insecRealChange($event)" v-model="insecDevice" filterable >
              <el-option :key="item.id" :label="item.name" :value="item.id" v-for="item in insecOptionList" >
                <span :class="item.state === 'red' ? 'red-circle' : 'green-circle'"></span>
                {{ item.name }}
              </el-option>
            </el-select>
          </div>
        </div>
      </div>
      <div class="insecReal-data-content" style="overflow:auto;">
        <div v-for="(row,index) in sliceList(insecDataList, 5)" :key="index" style=" width: 100%;height: 20%;">
          <div class="insecReal-content-body">
            <div class="insecReal-content-bodyContainer"  v-for="(item,i) in row">
              <div class="insecReal-content-container">
                <div class="insecReal-content-containerTr">
                  <div class="insecReal-content-containerTd">{{item.ts}}</div>
                </div>
                <div class="insecReal-content-containerTr">
                  <div class="insecReal-content-containerTd">{{item.name}}</div>
                </div>
                <div class="insecReal-content-containerTr">
                  <div class="insecReal-content-containerTd">{{item.value}}</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import {getDeviceValue} from "../../until/api/MeteSoil";
  import moment from 'moment'

  export default {
    name: 'InsecRealData',
    components: {},
    computed: {
      sliceList() {
        return function (data,count) {
          if(data != undefined) {
            let index = 0;
            let arrTemp = [];
            for(let i = 0; i < data.length; i++) {
              index = parseInt(i / count);
              if(arrTemp.length <= index) {
                arrTemp.push([])
              }
              arrTemp[index].push(data[i]);
            }
            return arrTemp;
          }
        }
      },
    },
    data() {
      return {
        insecOption: [],
        insecOptionList: [],
        insecDeviceJson: {},
        insecDevice: '',
        insecDeviceSate: '-',
        insecDataList: [],
        insecTime: null,
        insecOptionMap: null
      }
    },

    beforeDestroy() {
      clearInterval(this.insecTime);
      this.insecTime = null;
    },

    mounted() {
      let authority = this.$route.params.authority === undefined ? this.$commonFun.unCompileStr(localStorage.getItem('authority')) : this.$route.params.authority;
      let customerId = this.$route.params.customerId === undefined ? this.$commonFun.unCompileStr(localStorage.getItem('customerId')) : this.$route.params.customerId;

      let that = this;
      this.$MeteSoilCommon.getDeviceList(authority, customerId, function (deviceList) {
        that.insecDeviceBoard(deviceList);
      })
    },

    methods: {
      insecDeviceBoard(response) {
        if(response.data.length === 0) return;
        let promises = [];
        for(let i = 0; i < response.data.length; i++) {
          let insecJson = {
            id: response.data[i].id.id,
            name: response.data[i].name,
            type: response.data[i].id.entityType
          };
          let promise = this.$MeteSoilCommon.getLastConnectTime(insecJson.type, insecJson.id).then(time => {
            let beforeTime = new Date(moment().subtract(1, "hours")).getTime();
            insecJson.state = time < beforeTime ? 'red' :'green';
            return insecJson;
          })

          promises.push(promise);
        }

        Promise.all(promises).then(result => {
          this.insecOption = result;
          this.insecOptionMap = null;
          this.insecOptionMap = new Map(this.insecOption.map(item => [item.id, item]));
          if(this.insecOption.length > 0) {
            this.insecDeviceInfo(0, this.insecOption.length);
          }
        }).catch(error => {
          console.log("error", error);
        })
      },

      insecDeviceInfo(j, length) {
        let that = this;
        this.$MeteSoilCommon.getCredentialsInfo(this.insecOption[j].id, function (deviceInfo) {
          that.insecOption[j].deviceInfo = deviceInfo;
          that.$MeteSoilCommon.getDeviceKeyList(deviceInfo, function (keyData) {
            that.insecDeviceOption(j, keyData);
            if(++j < length) {
              that.insecDeviceInfo(j, length);
            }
          })
        })
      },

      insecDeviceOption(j, keyData) {
        let strKey = '';
        let keyList = keyData.split(',');
        for(let i = 0; i < keyList.length; i++) {
          if(keyList[i].indexOf('fxd_') >= 0) {
            strKey += keyList[i] + ',';
          }
        }

        if(strKey != '') {
          this.insecOptionList.push(this.insecOption[j]);

          if(this.insecDevice == '') {
            this.insecDevice = this.insecOptionList[0].id;
            this.insecDeviceJson = this.insecOptionList[0].deviceInfo;
            //获取设备最后一次连接时间
            this.insecConnectTime();
            //根据选中的设备获取设备数据
            this.insecDashInfo();
          }
        }
      },

      insecRealChange(event) {
        this.insecDevice = event;
        clearInterval(this.insecTime);
        this.insecTime = null;
        for(let i = 0; i < this.insecOptionList.length; i++) {
          if(this.insecOptionList[i].id == this.insecDevice) {
            this.insecDeviceJson = this.insecOptionList[i].deviceInfo;
            this.insecConnectTime();
            this.insecDashInfo();
            break;
          }
        }
      },

      insecDashInfo() {
        let that = this;
        this.$MeteSoilCommon.getDeviceKeyList(this.insecDeviceJson, function (keyData) {
          that.insecDeviceKeys(keyData);
        });

        this.insecTime = window.setInterval(() => {
          setTimeout(() => {
            this.$MeteSoilCommon.getDeviceKeyList(this.insecDeviceJson, function (keyData) {
              that.insecDeviceKeys(keyData);
            })
          }, 0)
        }, 1000 * 60)
      },

      insecDeviceKeys(keyData) {
        let keyList = keyData.split(",");
        let strKey = '';
        //筛选出墒情属性
        for(let i = 0; i < keyList.length; i++) {
          if(keyList[i].indexOf('fxd_') >= 0) {
            i == keyList.length - 1 ? strKey += keyList[i] : strKey += keyList[i] + ',';
          }
        }
        //获取设备value
        if(strKey != '') {
          this.insecDeviceValues(strKey);
        } else {
          this.soilDataList = [];
        }
      },

      insecDeviceValues(strKey) {
        let insecResponse = [];
        getDeviceValue(this.insecDeviceJson.entityType, this.insecDeviceJson.id, strKey).then(response => {
          for(let obj in response.data) {
            for(let i = 0; i < response.data[obj].length; i++) {
              let insecValue = {};
              insecValue.name = obj;
              insecValue.ts = response.data[obj][i].ts;
              insecValue.value = parseFloat(response.data[obj][i].value);
              insecResponse.push(insecValue);
            }
          }

          insecResponse.sort(function (a, b) {
            return b.ts < a.ts ? -1 : 1;
          });

          this.insecDataList = [];
          for(let i = 0; i < insecResponse.length; i++) {
            let insecValue = {};
            insecValue.ts = this.$commonFun.dateFormat(insecResponse[i].ts);
            insecValue.name = this.$t(insecResponse[i].name).split(',')[0];
            if(insecResponse[i].name == 'fxd_fanMode' || insecResponse[i].name == 'fxd_uvMode') {
              insecValue.value = insecResponse[i].value == 1 ? '开启' : '关闭';
            } else {
              insecValue.value = this.$t(insecResponse[i].name).split(",")[1] === undefined ?
                insecResponse[i].value : insecResponse[i].value + this.$t(insecResponse[i].name).split(",")[1];
            }

            this.insecDataList.push(insecValue);
          }
        }).catch(error => {
          console.log("error", error);
        })
      },

      insecConnectTime() {
        let option = this.insecOptionMap.get(this.insecDevice);
        if (option) {
          this.insecDeviceSate = option.state === 'red' ? '离线' : '在线';
        } else {
          // 如果没有找到对应的 id，设置默认值
          this.insecDeviceSate = '离线';
        }
      }
    }
  }
</script>

<style lang="less">
  @import "../less/InsecRealData";
</style>

<style>
  .insecReal-data-content::-webkit-scrollbar {
    display: none;
  }
  .red-circle {
    display: inline-block;
    width: 10px;
    height: 10px;
    background-color: red;
    border-radius: 50%;
    margin-right: 5px;
  }

  .green-circle {
    display: inline-block;
    width: 10px;
    height: 10px;
    background-color: green;
    border-radius: 50%;
    margin-right: 5px;
  }
</style>



// WEBPACK FOOTER //
// src/components/view/InsecRealData.vue